import React from "react";
import { Table } from "semantic-ui-react";
import { formatDate, getTimePart } from "@common/components/helpers/datetime";
import { HUMAN_DATE_FORMAT } from "@common/constants/datetime";
import { formatSecondsToTime } from "../../helpers/datetime";
import { formatCurrency } from "../../helpers/currency";

const CustomerSessionsTable = ({ headings, records }) => {
  return (
    <Table sortable>
      <Table.Header>
        <Table.Row>
          {headings.map((x) => (
            <Table.HeaderCell key={x.name}>
              <span>{x.label}</span>
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {records &&
          records?.data?.map((session, idx) => {
            return (
              <Table.Row className="clickable" key={`${session.guid}_${idx}`}>
                <Table.Cell>{session.sessionGuid}</Table.Cell>
                <Table.Cell>{session.gameTitle}</Table.Cell>
                <Table.Cell>{session.manufacturer}</Table.Cell>
                <Table.Cell>
                  {formatDate(session.sessionStart, HUMAN_DATE_FORMAT)}
                </Table.Cell>
                <Table.Cell>{getTimePart(session.sessionStart)}</Table.Cell>
                <Table.Cell>{formatCurrency(session.netLoss)}</Table.Cell>
                <Table.Cell>
                  {formatSecondsToTime(session.timeOnGame)}
                </Table.Cell>
                <Table.Cell>{session?.site?.id ?? "N/A"}</Table.Cell>
              </Table.Row>
            );
          })}
      </Table.Body>
    </Table>
  );
};
export default CustomerSessionsTable;
